export default __webpack_public_path__ + "static/media/smoke-texture-3.4976b2ac.png";